export default {"src":"/_next/static/media/carousel-icon-02.257c60eb.svg","height":56,"width":56,"blurWidth":0,"blurHeight":0};